function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Color from "terriajs-cesium/Source/Core/Color";
import ColorMap from "./ColorMap";
export default class DiscreteColorMap extends ColorMap {
  constructor(options) {
    super();
    _defineProperty(this, "includeMinimumInThisBin", void 0);
    _defineProperty(this, "maximums", void 0);
    _defineProperty(this, "colors", void 0);
    _defineProperty(this, "nullColor", void 0);
    const includeMinimumInThisBin = [];
    const maximums = [];
    const colors = [];
    options.bins.forEach(bin => {
      maximums.push(bin.maximum);
      includeMinimumInThisBin.push(bin.includeMinimumInThisBin);
      colors.push(Color.clone(bin.color));
    });
    this.includeMinimumInThisBin = [];
    this.maximums = maximums;
    this.colors = colors;
    this.nullColor = Color.clone(options.nullColor);
  }
  mapValueToColor(value) {
    if (typeof value !== "number") {
      return this.nullColor;
    }
    const maximums = this.maximums;
    let i, len;
    for (i = 0, len = maximums.length - 1; i < len && value > maximums[i]; ++i) {
      /* TODO: refactor */
    }

    // Value may equal maximum, in which case we look at
    // `includeMinimumInThisBin` for the _next_ bin.
    if (value === maximums[i] && i < this.includeMinimumInThisBin.length - 1 && this.includeMinimumInThisBin[i + 1]) {
      ++i;
    }
    return this.colors[i];
  }
}